import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useContext } from 'react';
import AppContext from '../AppContext';
import { MoveLicenseSystemInput, MoveLicenseSystemPayload } from './generated/types';

const mutation =
    `mutation MyMutation ($input: MoveLicenseSystemInput! ) {
        moveLicenseSystem(input: $input) {
            succeeded
        }
    }`;

export const useTransferLicenseSystem = (orgId: string, sourceLicenseSystemId: string) => {
    const context = useContext(AppContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (targetLicenseSystemId: string) => {

            const input: MoveLicenseSystemInput = { sourceLicenseSystemId, targetLicenseSystemId };

            const response = await (context.api.graphql({
                query: mutation,
                variables: { input },
            }) as Promise<{
                data: {
                    moveLicenseSystem: MoveLicenseSystemPayload;
                };
            }>);

            return response.data.moveLicenseSystem.succeeded;
        },
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: ['getOrganization', orgId] });
        },
    });
};